import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTheme, fonts } from "@/theme";
import { Icon } from "@/components/Icon";
import { Screen, TopBar, Loader } from "@/components/ui";
import { crystalsApi } from "@/data/api";
import { INTENTION_ICON, INTENTIONS_LIST } from "@/data/crystalsData";

export default function Intentions() {
  const { colors } = useTheme();
  const navigate = useNavigate();
  const [counts, setCounts] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    crystalsApi.meta().then((m) => setCounts(m.intention_counts || {})).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const list = INTENTIONS_LIST.filter((i) => (counts[i] || 0) > 0);
  const shown = list.length ? list : INTENTIONS_LIST;

  return (
    <Screen>
      <TopBar title="Browse by Intention ✨" />
      <div className="ritzy-fade" style={{ padding: "16px 20px 40px" }}>
        <div style={{ color: colors.muted, fontSize: 14, lineHeight: "20px", marginBottom: 16, fontFamily: fonts.text }}>
          Crystals commonly linked with these spiritual themes. Remember — associations, not promises.
        </div>
        {loading ? (
          <Loader />
        ) : (
          <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 12 }}>
            {shown.map((intention) => {
              const count = counts[intention] || 0;
              return (
                <button key={intention} data-testid={`intention-${intention}`} className="pressable" onClick={() => navigate(`/crystal-school/library?intention=${encodeURIComponent(intention)}&title=${encodeURIComponent(intention)}`)} style={{ display: "flex", flexDirection: "column", gap: 8, background: colors.surfaceSecondary, border: `1px solid ${colors.border}`, borderRadius: 18, padding: 16, cursor: "pointer", textAlign: "left" }}>
                  <div style={{ width: 40, height: 40, borderRadius: 12, background: colors.brandTertiary, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <Icon name={INTENTION_ICON[intention] ?? "star"} size={20} color={colors.onBrandTertiary} />
                  </div>
                  <div style={{ color: colors.onSurface, fontSize: 15, fontWeight: 700, fontFamily: fonts.text }}>{intention}</div>
                  <div style={{ color: colors.muted, fontSize: 12, fontFamily: fonts.text }}>{count} crystal{count === 1 ? "" : "s"}</div>
                </button>
              );
            })}
          </div>
        )}
      </div>
    </Screen>
  );
}
